import { createRootRouteWithContext } from '@tanstack/react-router';

import { ListUserOrgsQueryParamView } from '@crossnokaye/typescript-sdk/models/operations';

import { AppLayout } from '@/components/app-layout/app-layout';
import { transformUserState } from '@/hooks/use-user-state';
import { jotaiStore } from '@/providers/jotai/jotai-store';
import { listUserOrgsQuery } from '@/queries/iam/list-user-orgs-query';
import { queryClient } from '@/singletons';
import UserStateAtoms from '@/state/user.state';
import { RouterContext } from '@/types/router';
import { ATLAS_USER_IDENTIFIER_CLAIM } from '@/utils/auth-claims';

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ context }) => {
    // If there's no auth context, we're still loading.
    if (!context.auth) {
      return;
    }

    // If user is not authenticated, redirect to login.
    // Root layout will display a loading state in this case.
    if (!context.auth.isAuthenticated && !context.auth.error) {
      context.auth.login();
      return;
    }

    // Fetch and set user state in beforeLoad (runs serially before child loaders)
    const userState = await queryClient.ensureQueryData(
      listUserOrgsQuery({
        userId: context.auth.user?.[ATLAS_USER_IDENTIFIER_CLAIM],
        view: ListUserOrgsQueryParamView.FacilitiesExtended,
        client: context.atlasClient!,
      })
    );
    jotaiStore.set(UserStateAtoms.user, transformUserState(userState));
  },
  component: AppLayout,
});
